import { render, staticRenderFns } from "./CollectionConfirm.vue?vue&type=template&id=1fb57928&scoped=true&"
import script from "./CollectionConfirm.vue?vue&type=script&lang=js&"
export * from "./CollectionConfirm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionConfirm.vue?vue&type=style&index=0&id=1fb57928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb57928",
  null
  
)

export default component.exports